exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner_nav_height{min-height:29px!important}.set_nav{height:48px!important;margin-bottom:25px!important}.nav-item{padding:0}.nav-p{margin-bottom:1rem}.container{max-width:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43d1da44","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/moderators/Submissions.vue
// module id = J7iX
// module chunks = 0